// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NwX1J","noInteraction":"EventWrapper_noInteraction__rB_ey","pointerPassthrough":"EventWrapper_pointerPassthrough__zHOgm"};